let allCountries = [
	{
		"en": "AFGHANISTAN",
		"en_long": "Islamic State of Afghanistan",
		"zh": "阿富汗",
		"code": 301
	}, {
		"en": "ALBANIA",
		"en_long": "Republic of Albania",
		"zh": "阿尔巴尼亚",
		"code": 1
	}, {
		"en": "ALGERIA",
		"en_long": "Democratic People's Republic of Algeria",
		"zh": "阿尔及利亚",
		"code": 2
	}, {
		"en": "AMERICAN SAMOA",
		"en_long": "American Samoa",
		"zh": "美属萨摩亚",
		"code": 3
	}, {
		"en": "ANDORRA",
		"en_long": "Principality of Andorra",
		"zh": "安道尔",
		"code": 4
	}, {
		"en": "ANGOLA",
		"en_long": "Republic of Angola",
		"zh": "安哥拉",
		"code": 5
	}, {
		"en": "ANGUILLA",
		"en_long": "Anguilla",
		"zh": "安圭拉",
		"code": 6
	}, {
		"en": "ANTARCTICA",
		"en_long": "Antarctica",
		"zh": "南极洲",
		"code": 7
	}, {
		"en": "ANTIGUA AND BARBUDA",
		"en_long": "Antigua and Barbuda",
		"zh": "安提瓜和巴布达",
		"code": 8
	}, {
		"en": "ARGENTINA",
		"en_long": "Republic of Argentina",
		"zh": "阿根廷",
		"code": 9
	}, {
		"en": "ARMENIA",
		"en_long": "Republic of Armenia",
		"zh": "亚美尼亚",
		"code": 10
	}, {
		"en": "ARUBA",
		"en_long": "Aruba",
		"zh": "阿鲁巴",
		"code": 11
	}, {
		"en": "AUSTRALIA",
		"en_long": "Commonwealth of Australia",
		"zh": "澳大利亚",
		"code": 12
	}, {
		"en": "AUSTRIA",
		"en_long": "Republic of Austria",
		"zh": "奥地利",
		"code": 13
	}, {
		"en": "AZERBAIJAN",
		"en_long": "Republic of Azerbaijan",
		"zh": "阿塞拜疆",
		"code": 14
	}, {
		"en": "BAHAMAS",
		"en_long": "Commonwealth of the Bahamas",
		"zh": "巴哈马",
		"code": 15
	}, {
		"en": "BAHRAIN",
		"en_long": "State of Bahrain",
		"zh": "巴林",
		"code": 16
	}, {
		"en": "BANGLADESH",
		"en_long": "People's Republic of Bangladesh",
		"zh": "孟加拉国",
		"code": 17
	}, {
		"en": "BARBADOS",
		"en_long": "Barbados",
		"zh": "巴巴多斯",
		"code": 18
	}, {
		"en": "BELARUS",
		"en_long": "Republic of Belarus",
		"zh": "白俄罗斯",
		"code": 19
	}, {
		"en": "BELGIUM",
		"en_long": "Kingdom of belgium",
		"zh": "比利时",
		"code": 20
	}, {
		"en": "BELIZE",
		"en_long": "Belize",
		"zh": "伯利兹",
		"code": 21
	}, {
		"en": "BENIN",
		"en_long": "Republic of Benin",
		"zh": "贝宁",
		"code": 22
	}, {
		"en": "BERMUDA",
		"en_long": "Bermuda Islands",
		"zh": "百慕大",
		"code": 23
	}, {
		"en": "BHUTAN",
		"en_long": "Kingdom of Bhutan",
		"zh": "不丹",
		"code": 24
	}, {
		"en": "BOLIVIA",
		"en_long": "Republic of Bolivia",
		"zh": "玻利维亚",
		"code": 25
	}, {
		"en": "BOSNIA AND HERZEGOVINA",
		"en_long": "Bosnia and Herzegovina",
		"zh": "波黑",
		"code": 26
	}, {
		"en": "BOTSWANA",
		"en_long": "Republic of Botswana",
		"zh": "博茨瓦纳",
		"code": 27
	}, {
		"en": "BOUVET ISLAND",
		"en_long": "Bouvet Island",
		"zh": "布维岛",
		"code": 28
	}, {
		"en": "BRAZIL",
		"en_long": "Federative Republic of Brazil",
		"zh": "巴西",
		"code": 29
	}, {
		"en": "BRITISH INDIAN OCEAN TER-RITORY",
		"en_long": "British Indian Ocean Territory",
		"zh": "英属印度洋领土",
		"code": 30
	}, {
		"en": "BRUNEI DARUSSALAM",
		"en_long": "Brunei Darussalam",
		"zh": "文莱",
		"code": 31
	}, {
		"en": "BULGARIA",
		"en_long": "Republic ov Bulgaria",
		"zh": "保加利亚",
		"code": 32
	}, {
		"en": "BURKINA FASO",
		"en_long": "Burkina Faso",
		"zh": "布基纳法索",
		"code": 33
	}, {
		"en": "BURUNDI",
		"en_long": "Republic of Burundi",
		"zh": "布隆迪",
		"code": 34
	}, {
		"en": "CAMBODIA",
		"en_long": "Kingdom of Cambodia",
		"zh": "柬埔寨",
		"code": 35
	}, {
		"en": "CAMEROON",
		"en_long": "Republic of Cameroon",
		"zh": "喀麦隆",
		"code": 36
	}, {
		"en": "CANADA",
		"en_long": "Canada",
		"zh": "加拿大",
		"code": 37
	}, {
		"en": "CAPE VERDE",
		"en_long": "Republic of Cape Verde",
		"zh": "佛得角",
		"code": 38
	}, {
		"en": "CAYMAN ISLANDS",
		"en_long": "Cayman Islands",
		"zh": "开曼群岛",
		"code": 39
	}, {
		"en": "CENTRAL AFRICA",
		"en_long": "Central African Republic",
		"zh": "中非",
		"code": 40
	}, {
		"en": "CHAD",
		"en_long": "Republic of Chad",
		"zh": "乍得",
		"code": 41
	}, {
		"en": "CHILE",
		"en_long": "Republic of Chile",
		"zh": "智利",
		"code": 42
	}, {
		"en": "CHINA",
		"en_long": "People's Republic of China",
		"zh": "中国",
		"code": 43
	}, {
		"en": "CHRISTMAS ISLAND",
		"en_long": "Christmas Island",
		"zh": "圣诞岛",
		"code": 47
	}, {
		"en": "COCOS(KEELING) ISLANDS",
		"en_long": "Cocos(Keeling) Islands",
		"zh": "科科斯(基林)群岛",
		"code": 48
	}, {
		"en": "COLOMBIA",
		"en_long": "Republic of Colombia",
		"zh": "哥伦比亚",
		"code": 49
	}, {
		"en": "COMOROS",
		"en_long": "Federal Islamic Republic of the Co-moros",
		"zh": "科摩罗",
		"code": 50
	}, {
		"en": "CONGO",
		"en_long": "Republic of Congo",
		"zh": "刚果（布）",
		"code": 51
	}, {
		"en": "CONGO, THE DEMOCRATIC REPUBLIC OF THE",
		"en_long": "Democratic Republic of Congo",
		"zh": "刚果（金）",
		"code": 52
	}, {
		"en": "COOK ISLANDS",
		"en_long": "Cook Islands",
		"zh": "库克群岛",
		"code": 53
	}, {
		"en": "COSTA RICA",
		"en_long": "Republic of Costa Rica",
		"zh": "哥斯达黎加",
		"code": 54
	}, {
		"en": "COTE D'IVOIRE",
		"en_long": "Republic of Cote d'Ivire",
		"zh": "科特迪瓦",
		"code": 55
	}, {
		"en": "CROATIA",
		"en_long": "Republic of Croatia",
		"zh": "克罗地亚",
		"code": 56
	}, {
		"en": "CUBA",
		"en_long": "Republic of Cuba",
		"zh": "古巴",
		"code": 57
	}, {
		"en": "CYPRUS",
		"en_long": "Republic of Cyprus",
		"zh": "塞浦路斯",
		"code": 58
	}, {
		"en": "CZECH REPOUBLIC",
		"en_long": "Czech Republic",
		"zh": "捷克",
		"code": 59
	}, {
		"en": "DENMARK",
		"en_long": "Kingdom of Denmark",
		"zh": "丹麦",
		"code": 60
	}, {
		"en": "DJIBOUTI",
		"en_long": "Republic of Djibouti",
		"zh": "吉布提",
		"code": 61
	}, {
		"en": "DOMINICA",
		"en_long": "Commonwealth of Dominica",
		"zh": "多米尼克",
		"code": 62
	}, {
		"en": "DOMINICAN REPUBLIC",
		"en_long": "Dominican Republic",
		"zh": "多米尼加共和国",
		"code": 63
	}, {
		"en": "EAST TIMOR",
		"en_long": "East Timor",
		"zh": "东帝汶",
		"code": 64
	}, {
		"en": "ECUADOR",
		"en_long": "Republic of Ecuador",
		"zh": "厄瓜多尔",
		"code": 65
	}, {
		"en": "EGYPT",
		"en_long": "Arab Republic of Egypt",
		"zh": "埃及",
		"code": 66
	}, {
		"en": "EL SALVADOR",
		"en_long": "Republic of El Salvador",
		"zh": "萨尔瓦多",
		"code": 67
	}, {
		"en": "EQUATORIAL GUINEA",
		"en_long": "Republic of Equatorial Guinea",
		"zh": "赤道几内亚",
		"code": 68
	}, {
		"en": "ERITREA",
		"en_long": "State of Eritrea",
		"zh": "厄立特里亚",
		"code": 69
	}, {
		"en": "ESTONIA",
		"en_long": "Republic of Estonia",
		"zh": "爱沙尼亚",
		"code": 70
	}, {
		"en": "ETHIOPIA",
		"en_long": "Ethiopia",
		"zh": "埃塞俄比亚",
		"code": 71
	}, {
		"en": "FALKLAND ISLANDS(MALVINAS)",
		"en_long": "Falkland Islands(Malvinas)",
		"zh": "福克兰群岛(马尔维纳斯)",
		"code": 72
	}, {
		"en": "FAROE ISLANDS",
		"en_long": "Faroe Islands",
		"zh": "法罗群岛",
		"code": 73
	}, {
		"en": "FIJI",
		"en_long": "Republic of Fiji",
		"zh": "斐济",
		"code": 74
	}, {
		"en": "FINLAND",
		"en_long": "Republic of Finland",
		"zh": "芬兰",
		"code": 75
	}, {
		"en": "FRANCE",
		"en_long": "French Republic",
		"zh": "法国",
		"code": 76
	}, {
		"en": "FRENCH GUIANA",
		"en_long": "French Guiana",
		"zh": "法属圭亚那",
		"code": 77
	}, {
		"en": "FRENCH POLYNESIA",
		"en_long": "French Polynesia",
		"zh": "法属波利尼西亚",
		"code": 78
	}, {
		"en": "FRENCH SOUTHERN TERRITO-RIES",
		"en_long": "French Southern Territories",
		"zh": "法属南部领土",
		"code": 79
	}, {
		"en": "GABON",
		"en_long": "Gabonese Republic",
		"zh": "加蓬",
		"code": 80
	}, {
		"en": "GAMBIA",
		"en_long": "Republic of Gambia",
		"zh": "冈比亚Gambia",
		"code": 81
	}, {
		"en": "GEORGIA",
		"en_long": "Republic of Georgia",
		"zh": "格鲁吉亚",
		"code": 82
	}, {
		"en": "GERMANY",
		"en_long": "Federal Republic of Germany",
		"zh": "德国",
		"code": 83
	}, {
		"en": "GHANA",
		"en_long": "Republic of Ghana",
		"zh": "加纳",
		"code": 84
	}, {
		"en": "GIBRALTAR",
		"en_long": "Gibraltar",
		"zh": "直布罗陀",
		"code": 85
	}, {
		"en": "GREECE",
		"en_long": "Hellenic Republic",
		"zh": "希腊",
		"code": 86
	}, {
		"en": "GREENLAND",
		"en_long": "Greenland",
		"zh": "格陵兰",
		"code": 87
	}, {
		"en": "GRENADA",
		"en_long": "Grenada",
		"zh": "格林纳达",
		"code": 88
	}, {
		"en": "GUADELOUPE",
		"en_long": "Guadeloupe",
		"zh": "瓜德罗普",
		"code": 89
	}, {
		"en": "GUAM",
		"en_long": "Guam",
		"zh": "关岛",
		"code": 90
	}, {
		"en": "GUATEMALA",
		"en_long": "Republic of Guatemala",
		"zh": "危地马拉",
		"code": 91
	}, {
		"en": "GUINE-BISSAU",
		"en_long": "Republic of Guine-bissau",
		"zh": "几内亚比绍",
		"code": 93
	}, {
		"en": "GUINEA",
		"en_long": "Republic of Guinea",
		"zh": "几内亚",
		"code": 92
	}, {
		"en": "GUYANA",
		"en_long": "Cooperative Republic of Guyana",
		"zh": "圭亚那",
		"code": 94
	}, {
		"en": "HAITI",
		"en_long": "Republic of Haiti",
		"zh": "海地",
		"code": 95
	}, {
		"en": "HEARD ISLANDS AND MC DONALD ISLANDS",
		"en_long": "Heard islands and Mc Donald Islands",
		"zh": "赫德岛和麦克唐纳岛",
		"code": 96
	}, {
		"en": "HONDURAS",
		"en_long": "Republic of honduras",
		"zh": "洪都拉斯",
		"code": 97
	}, {
		"en": "Hong Kong, China",
		"en_long": "Hong Kong",
		"zh": "中国香港",
		"code": 44
	}, {
		"en": "HUNGARY",
		"en_long": "Republic of Hungary",
		"zh": "匈牙利",
		"code": 98
	}, {
		"en": "ICELAND",
		"en_long": "Republic of Iceland",
		"zh": "冰岛",
		"code": 99
	}, {
		"en": "INDIA",
		"en_long": "Republic of India",
		"zh": "印度",
		"code": 100
	}, {
		"en": "INDONESIA",
		"en_long": "Republic of Indonesia",
		"zh": "印度尼西亚",
		"code": 101
	}, {
		"en": "IRAN",
		"en_long": "Islamic Rupublic of Iran",
		"zh": "伊朗",
		"code": 102
	}, {
		"en": "IRAQ",
		"en_long": "Republic of Iraq",
		"zh": "伊拉克",
		"code": 103
	}, {
		"en": "IRELAND",
		"en_long": "Ireland",
		"zh": "爱尔兰",
		"code": 104
	}, {
		"en": "ISRAEL",
		"en_long": "State of Israel",
		"zh": "以色列",
		"code": 105
	}, {
		"en": "ITALY",
		"en_long": "Republic of Italy",
		"zh": "意大利",
		"code": 106
	}, {
		"en": "JAMAICA",
		"en_long": "Jamaica",
		"zh": "牙买加",
		"code": 107
	}, {
		"en": "JAPAN",
		"en_long": "Japan",
		"zh": "日本",
		"code": 108
	}, {
		"en": "JORDAN",
		"en_long": "Hashemite Kingdom of Jordan",
		"zh": "约旦",
		"code": 109
	}, {
		"en": "KAZAKHSTAN",
		"en_long": "Republic of Kazakhstan",
		"zh": "哈萨克斯坦",
		"code": 110
	}, {
		"en": "KENYA",
		"en_long": "Republic of Kenya",
		"zh": "肯尼亚",
		"code": 111
	}, {
		"en": "KIRIBATI",
		"en_long": "Republic of Kiribati",
		"zh": "基里巴斯",
		"code": 112
	}, {
		"en": "KOREA,DEMOCRATIC PEOPLE'S REPUBLIC OF",
		"en_long": "Democratic People's Republic of Korea",
		"zh": "朝鲜",
		"code": 113
	}, {
		"en": "KOREA,REPUBLIC OF",
		"en_long": "Republic of Korea",
		"zh": "韩国",
		"code": 114
	}, {
		"en": "KUWAIT",
		"en_long": "State of Kuwait",
		"zh": "科威特",
		"code": 115
	}, {
		"en": "KYRGYZSTAN",
		"en_long": "Kyrgyz Republic",
		"zh": "吉尔吉斯斯坦",
		"code": 116
	}, {
		"en": "LAOS",
		"en_long": "Lao People's Democratic Republic",
		"zh": "老挝",
		"code": 117
	}, {
		"en": "LATVIA",
		"en_long": "Republic of Latvia",
		"zh": "拉脱维亚",
		"code": 118
	}, {
		"en": "LEBANON",
		"en_long": "Republic of Lebanon",
		"zh": "黎巴嫩",
		"code": 119
	}, {
		"en": "LESOTHO",
		"en_long": "Kingdom of Lesoto",
		"zh": "莱索托",
		"code": 120
	}, {
		"en": "LIBERIA",
		"en_long": "Republic of Liberia",
		"zh": "利比里亚",
		"code": 121
	}, {
		"en": "LIBYA",
		"en_long": "Great Socialist People's Libyan Arab jamahiriya",
		"zh": "利比亚",
		"code": 122
	}, {
		"en": "LIECHTENSTEIN",
		"en_long": "Principality of Liechtenstein",
		"zh": "列支敦士登",
		"code": 123
	}, {
		"en": "LITHUANIA",
		"en_long": "Republic of Lithuania",
		"zh": "立陶宛",
		"code": 124
	}, {
		"en": "LUXEMBOURG",
		"en_long": "Grand Duchy of Luxembourg",
		"zh": "卢森堡",
		"code": 125
	}, {
		"en": "Macao, China",
		"en_long": "Macau",
		"zh": "中国澳门",
		"code": 45
	}, {
		"en": "The Republic of North Macedonia",
		"en_long": "The Former Yugoslav Republic of Macedonia",
		"zh": "北马其顿共和国",
		"code": 126
	}, {
		"en": "MADAGASCAR",
		"en_long": "Republic of Madagascar",
		"zh": "马达加斯加",
		"code": 127
	}, {
		"en": "MALAWI",
		"en_long": "Republic of Malawi",
		"zh": "马拉维",
		"code": 128
	}, {
		"en": "MALAYSIA",
		"en_long": "Malaysia",
		"zh": "马来西亚",
		"code": 129
	}, {
		"en": "MALDIVES",
		"en_long": "Republic of maldives",
		"zh": "马尔代夫",
		"code": 130
	}, {
		"en": "MALI",
		"en_long": "Republic of Mali",
		"zh": "马里",
		"code": 131
	}, {
		"en": "MALTA",
		"en_long": "Republic of Malta",
		"zh": "马耳他",
		"code": 132
	}, {
		"en": "MARSHALL ISLANDS",
		"en_long": "Republic of the marshall Islands",
		"zh": "马绍尔群岛",
		"code": 133
	}, {
		"en": "MARTINIQUE",
		"en_long": "Martinique",
		"zh": "马提尼克",
		"code": 134
	}, {
		"en": "MAURITANIA",
		"en_long": "Republic of Mauritius",
		"zh": "毛里塔尼亚",
		"code": 135
	}, {
		"en": "MAURITIUS",
		"en_long": "Republic of Mauritius",
		"zh": "毛里求斯",
		"code": 136
	}, {
		"en": "MAYOTTE",
		"en_long": "Mayotte",
		"zh": "马约特",
		"code": 137
	}, {
		"en": "MEXICO",
		"en_long": "United States of Mexico",
		"zh": "墨西哥",
		"code": 138
	}, {
		"en": "MICRONESIA, FEDERATED STATES OF",
		"en_long": "Federated States of Micronesia",
		"zh": "密克罗尼西亚联邦",
		"code": 139
	}, {
		"en": "MOLDOVA",
		"en_long": "Republic of Moldova",
		"zh": "摩尔多瓦",
		"code": 140
	}, {
		"en": "MONACO",
		"en_long": "Principality of Monaco",
		"zh": "摩纳哥",
		"code": 141
	}, {
		"en": "MONGOLIA",
		"en_long": "Mongolia",
		"zh": "蒙古",
		"code": 142
	}, {
		"en": "MONTSERRAT",
		"en_long": "Montserrat",
		"zh": "蒙特塞拉特",
		"code": 143
	}, {
		"en": "MOROCCO",
		"en_long": "Kingdom of Morocco",
		"zh": "摩洛哥",
		"code": 144
	}, {
		"en": "MOZAMBIQUE",
		"en_long": "Republic of Mozambique",
		"zh": "莫桑比克",
		"code": 145
	}, {
		"en": "MYANMAR",
		"en_long": "Union of Myanmar",
		"zh": "缅甸",
		"code": 146
	}, {
		"en": "NAMIBIA",
		"en_long": "Republic of Namibia",
		"zh": "纳米比亚",
		"code": 147
	}, {
		"en": "NAURU",
		"en_long": "Republic of Nauru",
		"zh": "瑙鲁",
		"code": 148
	}, {
		"en": "NEPAL",
		"en_long": "Kingdom of Nepal",
		"zh": "尼泊尔",
		"code": 149
	}, {
		"en": "NETHERLANDS",
		"en_long": "Kingdom of the Netherlands",
		"zh": "荷兰",
		"code": 150
	}, {
		"en": "NETHERLANDS ANTILLES",
		"en_long": "Netherlands Antilles",
		"zh": "荷属安的列斯",
		"code": 151
	}, {
		"en": "NEW CALEDONIA",
		"en_long": "New Caledonia",
		"zh": "新喀里多尼亚",
		"code": 152
	}, {
		"en": "NEW ZEALAND",
		"en_long": "New Zealand",
		"zh": "新西兰",
		"code": 153
	}, {
		"en": "NICARAGUA",
		"en_long": "Republic of Nicaragua",
		"zh": "尼加拉瓜",
		"code": 154
	}, {
		"en": "NIGER",
		"en_long": "Republic of Niger",
		"zh": "尼日尔",
		"code": 155
	}, {
		"en": "NIGERIA",
		"en_long": "Federal Republic of Nigeria",
		"zh": "尼日利亚",
		"code": 156
	}, {
		"en": "NIUE",
		"en_long": "Niue",
		"zh": "纽埃",
		"code": 157
	}, {
		"en": "NORFOLK ISLAND",
		"en_long": "Norfolk Island",
		"zh": "诺福克岛",
		"code": 158
	}, {
		"en": "NORTHERN MARIANAS",
		"en_long": "Commonwealth of the Northern Marianas",
		"zh": "北马里亚纳",
		"code": 159
	}, {
		"en": "NORWAY",
		"en_long": "Kingdom of Norway",
		"zh": "挪威",
		"code": 160
	}, {
		"en": "OMAN",
		"en_long": "Sultanate of Oman",
		"zh": "阿曼",
		"code": 161
	}, {
		"en": "PAKISTAN",
		"en_long": "Islamic Republic of Pakistan",
		"zh": "巴基斯坦",
		"code": 162
	}, {
		"en": "PALAU",
		"en_long": "Republic of Palau",
		"zh": "帕劳",
		"code": 163
	}, {
		"en": "PALESTINE",
		"en_long": "State of Palestine",
		"zh": "巴勒斯坦",
		"code": 164
	}, {
		"en": "PANAMA",
		"en_long": "Republic of Panama",
		"zh": "巴拿马",
		"code": 165
	}, {
		"en": "PAPUA NEW GUINEA",
		"en_long": "Independent State of Papua New Guinea",
		"zh": "巴布亚新几内亚",
		"code": 166
	}, {
		"en": "PARAGUAY",
		"en_long": "Republic of Paraguay",
		"zh": "巴拉圭",
		"code": 167
	}, {
		"en": "PERU",
		"en_long": "Republic of Peru",
		"zh": "秘鲁",
		"code": 168
	}, {
		"en": "PHILIPPINES",
		"en_long": "Republic of the Philippines",
		"zh": "菲律宾",
		"code": 169
	}, {
		"en": "PITCAIRN ISLANDS GROUP",
		"en_long": "Pitcairn Islands Group",
		"zh": "皮特凯恩群岛",
		"code": 170
	}, {
		"en": "POLAND",
		"en_long": "Republic of Poland",
		"zh": "波兰",
		"code": 171
	}, {
		"en": "PORTUGAL",
		"en_long": "Pirtuguese Republic",
		"zh": "葡萄牙",
		"code": 172
	}, {
		"en": "PUERTO RICO",
		"en_long": "Commonwealth of Puerto Rico",
		"zh": "波多黎各",
		"code": 173
	}, {
		"en": "QATAR",
		"en_long": "State of Qatar",
		"zh": "卡塔尔",
		"code": 174
	}, {
		"en": "REUNION",
		"en_long": "Reunion",
		"zh": "留尼汪",
		"code": 175
	}, {
		"en": "ROMANIA",
		"en_long": "Romania",
		"zh": "罗马尼亚",
		"code": 176
	}, {
		"en": "RUSSIAN FEDERATION",
		"en_long": "Russian Federation",
		"zh": "俄罗斯联邦",
		"code": 177
	}, {
		"en": "RWANDA",
		"en_long": "Republic of Rwanda",
		"zh": "卢旺达",
		"code": 178
	}, {
		"en": "SAINT HELENA",
		"en_long": "Saint Helena",
		"zh": "圣赫勒拿",
		"code": 179
	}, {
		"en": "SAINT KITTS AND NEVIS",
		"en_long": "Federation of Saint Kitts and nevis",
		"zh": "圣基茨和尼维斯",
		"code": 180
	}, {
		"en": "SAINT LUCIA",
		"en_long": "Saint Lucia",
		"zh": "圣卢西亚",
		"code": 181
	}, {
		"en": "SAINT PIERRE AND MIQUELON",
		"en_long": "Saint Pierre and Miquelon",
		"zh": "圣皮埃尔和密克隆",
		"code": 182
	}, {
		"en": "SAINT VINCENT AND THE GRENADINES",
		"en_long": "Saint Vincent and the Grenadines",
		"zh": "圣文森特和格林纳丁斯",
		"code": 183
	}, {
		"en": "SAMOA",
		"en_long": "Independent State of Samoa",
		"zh": "萨摩亚",
		"code": 184
	}, {
		"en": "SAN MARION",
		"en_long": "Republic of San Marino",
		"zh": "圣马力诺",
		"code": 185
	}, {
		"en": "SAO TOME AND PRINCIPE",
		"en_long": "Democratic Republic of Sao Tome and Principe",
		"zh": "圣多美和普林西比",
		"code": 186
	}, {
		"en": "SAUDI ARABIA",
		"en_long": "Kingdom of Saudi Arabia",
		"zh": "沙特阿拉伯",
		"code": 187
	}, {
		"en": "SENEGAL",
		"en_long": "Republic of Senegal",
		"zh": "塞内加尔",
		"code": 188
	}, {
		"en": "SEYCHELLS",
		"en_long": "Republic of Seychelles",
		"zh": "塞舌尔",
		"code": 189
	}, {
		"en": "SIERRA LEONE",
		"en_long": "Republic of Sierra Leone",
		"zh": "塞拉利昂",
		"code": 190
	}, {
		"en": "SINGAPORE",
		"en_long": "Republic of Singapore",
		"zh": "新加坡",
		"code": 191
	}, {
		"en": "SLOVAKIA",
		"en_long": "Slovak Republic",
		"zh": "斯洛伐克",
		"code": 192
	}, {
		"en": "SLOVENIA",
		"en_long": "Republic of Slovenia",
		"zh": "斯洛文尼亚",
		"code": 193
	}, {
		"en": "SOLOMON ISLANDS",
		"en_long": "Solomon Islands",
		"zh": "所罗门群岛",
		"code": 194
	}, {
		"en": "SOMALIA",
		"en_long": "Somali Republic",
		"zh": "索马里",
		"code": 195
	}, {
		"en": "SOUTH AFRICA",
		"en_long": "Republic of South Africa",
		"zh": "南非",
		"code": 196
	}, {
		"en": "SOUTH GEORGIA AND SOUTH SANDWICH ISLANDS",
		"en_long": "South Georgia and South Sandwich Islands",
		"zh": "南乔治亚岛和南桑德韦奇岛",
		"code": 197
	}, {
		"en": "SPAIN",
		"en_long": "Spain",
		"zh": "西班牙",
		"code": 198
	}, {
		"en": "SRI LANKA",
		"en_long": "Democratic Socialist Republic of Srilanka",
		"zh": "斯里兰卡",
		"code": 199
	}, {
		"en": "SUDAN",
		"en_long": "Republic of the Sudan",
		"zh": "苏丹",
		"code": 200
	}, {
		"en": "SURINAME",
		"en_long": "Republic of Suriname",
		"zh": "苏里南",
		"code": 201
	}, {
		"en": "SVALBARD AND JAN MAYEN ISLANDS",
		"en_long": "Svalbard and Jan mayen islands",
		"zh": "斯瓦尔巴群岛",
		"code": 202
	}, {
		"en": "SWAZILAND",
		"en_long": "Kingdom of Swaziland",
		"zh": "斯威士兰",
		"code": 203
	}, {
		"en": "SWEDEN",
		"en_long": "Kingdom of Sweden",
		"zh": "瑞典",
		"code": 204
	}, {
		"en": "SWITZERLAND",
		"en_long": "Swiss Confederation",
		"zh": "瑞士",
		"code": 205
	}, {
		"en": "SYRIA",
		"en_long": "Syrian Arab Republic",
		"zh": "叙利亚",
		"code": 206
	}, {
		"en": "Taiwan, China",
		"en_long": "Taiwan, Province of China",
		"zh": "中国台湾",
		"code": 46
	}, {
		"en": "TAJIKISTAN",
		"en_long": "Republic of Tajikistan",
		"zh": "塔吉克斯坦",
		"code": 207
	}, {
		"en": "TANZANIA",
		"en_long": "United Republic of Tanzania",
		"zh": "坦桑尼亚",
		"code": 208
	}, {
		"en": "THAILAND",
		"en_long": "Kingdom of Thailand",
		"zh": "泰国",
		"code": 209
	}, {
		"en": "TOGO",
		"en_long": "Republic of Tago",
		"zh": "多哥",
		"code": 210
	}, {
		"en": "TOKELAU",
		"en_long": "Tokelau",
		"zh": "托克劳",
		"code": 211
	}, {
		"en": "TONGA",
		"en_long": "Kingdom of Tonga",
		"zh": "汤加",
		"code": 212
	}, {
		"en": "TRINIDAD AND TOBAGO",
		"en_long": "Republic of Trinidad and Tobago",
		"zh": "特立尼达和多巴哥",
		"code": 213
	}, {
		"en": "TUNISIA",
		"en_long": "Republic of Tunisia",
		"zh": "突尼斯",
		"code": 214
	}, {
		"en": "TURKEY",
		"en_long": "Republic of Turkey",
		"zh": "土耳其",
		"code": 215
	}, {
		"en": "TURKMENISTAN",
		"en_long": "Turkmenistan",
		"zh": "土库曼斯坦",
		"code": 216
	}, {
		"en": "TURKS AND CAICOS ISLANDS",
		"en_long": "Turks and Caicos Islands",
		"zh": "特克斯和凯科斯群岛",
		"code": 217
	}, {
		"en": "TUVALU",
		"en_long": "Tuvalu",
		"zh": "图瓦卢",
		"code": 218
	}, {
		"en": "UGANDA",
		"en_long": "Republic of Uganda",
		"zh": "乌干达",
		"code": 219
	}, {
		"en": "UKRAINE",
		"en_long": "Ukraine",
		"zh": "乌克兰",
		"code": 220
	}, {
		"en": "UNITED ARAB EMIRATES",
		"en_long": "United Arab Emirates",
		"zh": "阿联酋",
		"code": 221
	}, {
		"en": "UNITED KINGDOM",
		"en_long": "United Kingdom of Great Britain and Northern ireland",
		"zh": "英国",
		"code": 222
	}, {
		"en": "UNITED STATES",
		"en_long": "United States of America",
		"zh": "美国",
		"code": 223
	}, {
		"en": "UNITED STATES MINOR OUTLYING ISLANDS",
		"en_long": "United States Minor Outlying Islands",
		"zh": "美国本土外小岛屿",
		"code": 224
	}, {
		"en": "URUGUAY",
		"en_long": "Oriental Republic of Uruguay",
		"zh": "乌拉圭",
		"code": 225
	}, {
		"en": "UZBEKISTAN",
		"en_long": "Republic of Uzbekistan",
		"zh": "乌兹别克斯坦",
		"code": 226
	}, {
		"en": "VANUATU",
		"en_long": "Republic of Vanuatu",
		"zh": "瓦努阿图",
		"code": 227
	}, {
		"en": "VATICAN",
		"en_long": "Vatican City State",
		"zh": "梵蒂冈",
		"code": 228
	}, {
		"en": "VENEZUELA",
		"en_long": "Republic of Venezuela",
		"zh": "委内瑞拉",
		"code": 229
	}, {
		"en": "VIET NAM",
		"en_long": "Socialist Republic of Viet Nam",
		"zh": "越南",
		"code": 230
	}, {
		"en": "VIRGIN ISLANDS, BRITISH ",
		"en_long": "British Virgin Islands",
		"zh": "英属维尔京群岛",
		"code": 231
	}, {
		"en": "VIRGIN ISLANDS,U.S.",
		"en_long": "Virgin Islands of the United States",
		"zh": "美属维尔京群岛",
		"code": 232
	}, {
		"en": "WALLIS AND FUTUNA",
		"en_long": "Wallis and Futuna",
		"zh": "瓦利斯和富图纳",
		"code": 233
	}, {
		"en": "WESTERN SAHARA",
		"en_long": "Western Sahara",
		"zh": "西撒哈拉",
		"code": 234
	}, {
		"en": "YEMEN",
		"en_long": "Republic of Yemen",
		"zh": "也门",
		"code": 235
	}, {
		"en": "YUGOSLAVIA",
		"en_long": "Federal Republic of Yugoslavia",
		"zh": "南斯拉夫",
		"code": 236
	}, {
		"en": "ZAMBIA",
		"en_long": "Republic of Zambia",
		"zh": "赞比亚",
		"code": 237
	}, {
		"en": "ZIMBABWE",
		"en_long": "Republic of Zimbabwe",
		"zh": "津巴布韦",
		"code": 238
	}, {
		"en": "The Republic of Serbia",
		"en_long": "The Republic of Serbia",
		"zh": "塞尔维亚共和国",
		"code": 239
	}, {
		"en": "Montenegro",
		"en_long": "Montenegro",
		"zh": "黑山",
		"code": 240
	}, {
		"en": "Azores",
		"en_long": "Azores",
		"zh": "亚速尔群岛",
		"code": 241
	}, {
		"en": "madeira",
		"en_long": "madeira",
		"zh": "马德拉群岛",
		"code": 242
	}, {
		"en": "Islas Canarias",
		"en_long": "Islas Canarias",
		"zh": "加那利群岛",
		"code": 243
	}, {
		"en": "The Republic of South Sudan",
		"en_long": "The Republic of South Sudan",
		"zh": "南苏丹",
		"code": 244
	}, {
		"en": "Reunion Island",
		"en_long": "Reunion Island",
		"zh": "留尼汪岛",
		"code": 245
	}, {
		"en": "Autonomous country",
		"en_long": "Autonomous country",
		"zh": "荷属圣马丁",
		"code": 246
	}, {
		"en": "Saint-Martin",
		"en_long": "Saint-Martin",
		"zh": "法属圣马丁",
		"code": 247
	}, {
		"en": "Saint Barthelemy",
		"en_long": "Saint Barthelemy",
		"zh": "圣巴泰勒米岛",
		"code": 248
	}, {
		"en": "Curaçao",
		"en_long": "Curaçao",
		"zh": "库拉索",
		"code": 249
	}];

export default allCountries;